<!--转单产品-->
<template>
  <Page class="queryView">
    <template v-slot:contentTop>
      <div class="queryView-conditions with-btn-end">
        <a-form layout="inline" :form="form">
          <a-form-item label="模版名称">
            <a-input v-decorator="['materialTemplateName']" placeholder="请输入模版名称"></a-input>
          </a-form-item>
          <a-form-item label="国家名称">
            <a-input v-decorator="['countryName']" placeholder="请输入国家名称"></a-input>
          </a-form-item>
        </a-form>
        <div class="condition-btns">
          <a-button class="app-btn" type="default" @click="resetAndQuery$qv">重置搜索</a-button>
          <a-button class="app-btn" type="primary" @click="doQuery(1)">立即搜索</a-button>
        </div>
      </div>
    </template>
    <div>
      <div class="pageContent-title">模版列表</div>
      <div class="queryView-actions">
        <a-button class="app-btn" @click="addRow">
          <app-icon type="icon-tianjia"></app-icon>
          添加模版
        </a-button>
      </div>
      <div class="queryView-main">
        <a-table
          class="mt-5"
          :rowKey="useRowIndex"
          bordered
          :loading="tableLoading"
          :columns="tableColumns"
          :scroll="{ x: 1400 }"
          :dataSource="dataSource"
          @change="handleTableChange$qv"
          :pagination="{
            current: pageNumber,
            pageSize: pageSize,
            total: countTotal,
            showSizeChanger: true,
            showQuickJumper: true,
          }"
        ></a-table>
      </div>
    </div>
    <SetSupplyModal ref="supplyModal"></SetSupplyModal>
  </Page>
</template>

<script>
import Page from '@/components/Page'
import { queryViewMixin, toolMixin } from '@/utils/mixin'
import SetSupplyModal from './modules/SetSupplyModal'
export default {
  mixins: [queryViewMixin, toolMixin],
  data() {
    const tableColumns = [
      {
        title: '序号',
        width: '5%',
        align: 'center',
        // dataIndex: 'userName',
        customRender: (text, row, index) => {
          return <div>{this.pageSize * (this.pageNumber - 1) + index + 1}</div>
        },
      },
      {
        title: '模版名称',
        width: '35%',
        align: 'center',
        dataIndex: 'materialTemplateName',
      },
      {
        title: '国家',
        width: '35%',
        align: 'center',
        dataIndex: 'countryName',
      },
      {
        title: '操作',
        width: '25%',
        align: 'center',
        dataIndex: 'detail',
        customRender: (text, row, index) => {
          return (
            <div class="flex gap-4 justify-center items-center text-primary-500">
              <app-icon
                type="icon-bianji"
                onClick={() => {
                  this.editRow(row)
                }}
              ></app-icon>
              <app-icon
                type="icon-shanchu"
                onClick={() => {
                  this.removeRow(row)
                }}
              ></app-icon>
            </div>
          )
        },
      },
    ]
    return {
      form: this.$form.createForm(this),
      pageNumber: 1,
      pageSize: 10,
      countTotal: 0,
      tableLoading: false,
      tableColumns: tableColumns,
      modal: {
        visible: false,
        title: '',
        data: {},
      },
      dataSource: [],
    }
  },
  components: {
    Page,
    SetSupplyModal,
  },
  computed: {
    typesMap() {
      return {}
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.path === '/m/scopeMain/transferProduct/addProductsType') {
        const query = vm.$store.state.app.query
        vm.pageNumber = parseInt(query.index)
        vm.productName = query.name
      }
    })
  },
  async mounted() {
    this.doQuery()
  },
  methods: {
    getParams() {
      const params = this.form.getFieldsValue()
      return {
        ...params,
      }
    },
    async doQuery(pageNumber) {
      this.tableLoading = true
      try {
        const res = await this.$axios.post(
          '/visa/admin/productMaterialTemplate/queryTemplateByProductType',
          {
            data: {
              productType: 1,
              ...this.getParams(),
            },
            pageNumber: pageNumber || this.pageNumber,
            pageSize: this.pageSize,
          }
        )
        // this.countTotal = Number(res.total)
        // this.pageSize = size
        // this.pageNumber = number
        this.dataSource = res.data
      } catch (e) {
        console.log(e)
      }
      this.tableLoading = false
    },

    async setSupplyClick(row) {
      await this.$refs.supplyModal.start(row)
      this.doQuery()
    },
    async removeRow(row) {
      await new Promise((resolve, reject) => {
        this.$confirm({
          title: '提示',
          content: '确定删除?',
          onOk: () => {
            resolve()
          },
          onCancel: () => {
            reject(new Error('E_CANCEL'))
          },
        })
      })
      await this.$axios.post('/visa/admin/productMaterialTemplate/deleteByTemplateId', {
        data: {
          materialTemplateId: row.materialTemplateId,
        },
      })
      this.$message.success('操作成功')
      this.doQuery()
    },
    async changeOnShelf(row) {
      await this.$axios.post('/visa/admin/productTransfer/setProductOnShelf', {
        data: {
          productId: row.productId,
          isOnShelf: row.isOnShelf === 0 ? 1 : 0,
        },
      })
      this.$message.success('操作成功')
      this.doQuery()
    },
    addRow() {
      this.$router.push({
        path: '/m/scopeMain/transferProduct/addProductsType',
        query: {
          edit: 'add',
        },
      })
    },
    editRow(row) {
      this.$store.commit('SET_QUERY', { name: this.form.productName, index: this.pageNumber })
      this.$router.push({
        path: '/m/scopeMain/transferProduct/addProductsType',
        query: {
          materialTemplateId: row.materialTemplateId,
        },
      })
    },
    copyRow(row) {
      this.$router.push({
        path: '/m/scopeMain/transferProduct/addProductsType',
        query: {
          copyId: row.productId,
        },
      })
    },
  },
}
</script>

<style lang="less"></style>
